/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import CardLayout from "../../Cards/CardLayout";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { IDevice } from "../../../utils/interfaces";
import Loader from "../../feedBacks/loader";
import CardError from "../../feedBacks/CardError";
import { formatCustomDate, THRESHOLD } from "../../../utils/utils";
import { Link } from "react-router-dom";
import { REFETCH_CONFIGURATION } from "../../../utils/constants";
import NoDeviceCardError from "../../feedBacks/NoDeviceCardError";
import {
  blueMarker,
  deepGreenMarker,
  greyMarker,
  lightGreenMarker,
  orangeMarker,
  redMarker,
  yellowMarker,
} from "../../../assets/map";
import HierarchicalSelector from "./Selector";
import Loader2 from "../../feedBacks/loader2";
import { useUtils } from "../../../customHooks/useUtils";

interface IResponse {
  condition: string;
  devices: IDevice[];
}

// Fix for Leaflet marker icons
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

// Create marker icons
// Red marker icon for critical conditions
const redIcon = new L.Icon({
  iconUrl: redMarker,
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160306.png",
  iconRetinaUrl: redMarker,
  // iconRetinaUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160306.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const blueIcon = new L.Icon({
  iconUrl: blueMarker,
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  iconRetinaUrl: blueMarker,
  // iconRetinaUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
const lightGreenIcon = new L.Icon({
  iconUrl: lightGreenMarker,
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  iconRetinaUrl: lightGreenMarker,
  // iconRetinaUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const deepGreenIcon = new L.Icon({
  iconUrl: deepGreenMarker,
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  iconRetinaUrl: deepGreenMarker,
  // iconRetinaUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Orange marker icon for warning conditions
const orangeIcon = new L.Icon({
  iconUrl: orangeMarker,
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160358.png",
  iconRetinaUrl: orangeMarker,
  // iconRetinaUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160358.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Yellow marker icon for warning conditions
const yellowIcon = new L.Icon({
  iconUrl: yellowMarker,
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160358.png",
  iconRetinaUrl: yellowMarker,
  // iconRetinaUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160358.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Orange marker icon for warning conditions
const greyIcon = new L.Icon({
  iconUrl: greyMarker,
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160358.png",
  iconRetinaUrl: greyMarker,
  // iconRetinaUrl: "https://cdn-icons-png.flaticon.com/512/1160/1160358.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Custom component to control markers and their popups
const CustomMarker = ({
  site,
  getIconForCondition,
  getTextClassForCondition,
  condition,
}: any) => {
  const markerRef = useRef(null);
  const [isPinned, setPinned] = React.useState(false);

  const handleMarkerClick = () => {
    setPinned(!isPinned);

    if (!isPinned) {
      if (markerRef.current) {
        // @ts-ignore - We know marker has openPopup method
        markerRef.current.openPopup();
      }
    }
  };

  // Update the autoPan option to ensure popup stays visible when opening
  const popupOptions = {
    autoPan: true,
    closeButton: true,
    closeOnClick: false,
    closeOnEscapeKey: false,
    autoClose: !isPinned,
  };
  const { CONDITIONS } = useUtils();
  return (
    <Marker
      ref={markerRef}
      position={site.position}
      icon={getIconForCondition(condition, site.condition)}
      eventHandlers={{
        click: handleMarkerClick,
        mouseover: (e) => {
          if (!isPinned) {
            e.target.openPopup();
          }
        },
        mouseout: (e) => {
          if (!isPinned) {
            e.target.closePopup();
          }
        },
      }}
    >
      <Popup {...popupOptions}>
        <div className="popup-content">
          <h4 className="font-semibold my-0">{site.asset_name}</h4>
          <p className="!mt-1">{site.description}</p>
          <p className={getTextClassForCondition(condition, site.condition)}>
            {`${CONDITIONS.find((cond) => cond.value === condition)?.key}: ${
              typeof site.condition === "boolean"
                ? site.condition
                  ? "Online"
                  : "Offline"
                : site.condition
            }`}
          </p>
          <span>
            {" "}
            Last seen{" "}
            <span className=" font-bold">
              {formatCustomDate(site.last_seen)}
            </span>
          </span>
          <Link
            to={`/dashboard/operations/site/${site.id}`}
            className="!text-primary-yellowMain text-sm italic block mt-2 mb-1"
          >
            View
          </Link>
          <button
            onClick={() => setPinned(!isPinned)}
            className={`text-xs px-2 py-1 mt-1 rounded ${
              isPinned ? "bg-gray-200" : "bg-gray-100"
            }`}
          >
            {isPinned ? "Unpin popup" : "Pin popup"}
          </button>
        </div>
      </Popup>
    </Marker>
  );
};
const MapLegend = ({
  condition,
  siteData,
}: {
  condition: string;
  siteData: any[];
}) => {
  const { t, CONDITION_LABELS } = useUtils();
  // Get the labels for the current condition
  const labels = (CONDITION_LABELS as any)[condition] || {};
  // Memoized device counts for each range
  const deviceCounts = useMemo(() => {
    const ranges = (THRESHOLD as any)[condition];
    if (!ranges) return {};

    const counts: { [key: string]: number } = {};

    // Initialize counts for all available ranges in the current condition
    Object.keys(ranges).forEach((rangeType) => {
      counts[rangeType] = 0;
    });

    // Count devices for each range
    siteData.forEach((site) => {
      const value = site.condition;

      // Check each range type available for this condition
      Object.keys(ranges).forEach((rangeType) => {
        const range = ranges[rangeType];

        // Handle boolean type
        if (typeof value === "boolean") {
          if (value === range) {
            counts[rangeType]++;
          }
        }

        // Handle numeric ranges
        if (typeof value === "number") {
          if (value <= 0 && rangeType === "grey") {
            counts[rangeType]++;
          } else if (range && typeof range === "object") {
            // Check main range
            if (value >= range.min && value <= range.max) {
              counts[rangeType]++;
            }
            // Check alternative range if exists
            else if (
              range.altMin &&
              range.altMax &&
              value >= range.altMin &&
              value <= range.altMax
            ) {
              counts[rangeType]++;
            }
          }
        }
      });
    });

    return counts;
  }, [condition, siteData]);

  return (
    <div className="absolute bottom-6 right-4 bg-white p-3 rounded-md shadow-md z-[30] text-sm">
      <div className="flex flex-wrap gap-4">
        {labels.blue && (
          <div className="flex flex-col gap-1 border-l-4 border-l-blue-400 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-blue-400"></div>
              <span>{labels.blue}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.blue || 0}{" "}
              {deviceCounts.blue > 1 ? t("common.devices") : t("common.device")}
            </span>
          </div>
        )}

        {labels.deepGreen && (
          <div className="flex flex-col gap-1 border-l-4 border-l-green-600 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-green-600"></div>
              <span>{labels.deepGreen}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.deepGreen || 0}{" "}
              {deviceCounts.deepGreen > 1
                ? t("common.devices")
                : t("common.device")}
            </span>
          </div>
        )}

        {labels.lightGreen && (
          <div className="flex flex-col gap-1 border-l-4 border-l-green-300 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-green-300"></div>
              <span>{labels.lightGreen}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.lightGreen || 0}{" "}
              {deviceCounts.lightGreen > 1
                ? t("common.devices")
                : t("common.device")}
            </span>
          </div>
        )}

        {labels.yellow && (
          <div className="flex flex-col gap-1 border-l-4 border-l-yellow-500 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <span>{labels.yellow}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.yellow || 0}{" "}
              {deviceCounts.yellow > 1
                ? t("common.devices")
                : t("common.device")}
            </span>
          </div>
        )}

        {labels.orange && (
          <div className="flex flex-col gap-1 border-l-4 border-l-orange-500 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-orange-500"></div>
              <span>{labels.orange}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.orange || 0}{" "}
              {deviceCounts.orange > 1
                ? t("common.devices")
                : t("common.device")}
            </span>
          </div>
        )}

        {labels.red && (
          <div className="flex flex-col gap-1 border-l-4 border-l-red-600 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-red-600"></div>
              <span>{labels.red}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.red || 0}{" "}
              {deviceCounts.red > 1 ? t("common.devices") : t("common.device")}
            </span>
          </div>
        )}

        {labels.green && (
          <div className="flex flex-col gap-1 border-l-4 border-l-green-600 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-green-600"></div>
              <span>{labels.green}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.green || 0}{" "}
              {deviceCounts.green > 1
                ? t("common.devices")
                : t("common.device")}
            </span>
          </div>
        )}

        {labels.grey && (
          <div className="flex flex-col gap-1 border-l-4 border-l-gray-600 pl-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-gray-600"></div>
              <span>{labels.grey}</span>
            </div>
            <span className="h-5 w-full text-center text-xs font-semibold">
              {deviceCounts.grey || 0}{" "}
              {deviceCounts.grey > 1 ? t("common.devices") : t("common.device")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
const SiteLocationMap = ({ company_id }: { company_id: string }) => {
  const { t, CONDITIONS } = useUtils();
  const [condition, setCondition] = React.useState<string>(CONDITIONS[0].value);
  // const [zoneId, setZoneId] = React.useState<string>("");
  const [classficationId, setClassficationId] = React.useState<string>("");
  // const [isZoneLoading, setIsZoneLoading] = React.useState(false);
  const [isClassificationLoading, setisClassificationLoading] =
    React.useState(false);
  const {
    data,
    isLoading: isDataLoading,
    error,
    refetch,
  } = useFetchData(
    ["/map", "fetchSiteMap", company_id, condition],
    "fetch-map",
    {
      condition,
      company_id,
      // zone_id: zoneId,
      classification_id: classficationId,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );
  const isLoading = isDataLoading || isClassificationLoading;

  const {
    data: classificationData,
    isLoading: classificationLoading,
    error: classificationError,
  } = useFetchData(
    ["/classifications", "fetchAssetClassifications", company_id],
    "/classifications/",
    {
      company_id,
    },
    // @ts-ignore
    {}
  );

  const handleClassificationChange = (e: any) => {
    setisClassificationLoading(true);
    setClassficationId(e);
  };

  const handleConditionChange = (condition: string) => {
    setCondition(condition);
  };

  const getPosition = (lat: number, long: number) => {
    // const [lat, long] = co_ordinate.split(',');
    return [lat, long];
  };

  const siteData =
    (data as IResponse)?.devices?.map((device) => ({
      ...device,
      position: getPosition(device.latitude, device.longitude),
    })) || [];

  const getTextClassForCondition = (
    conditionType: string,
    value: any
  ): string => {
    const ranges = (THRESHOLD as any)[conditionType];

    if (!ranges) {
      return "text-primary-blackMain"; // Default fallback
    }

    // Handle boolean type (transformer_status)
    if (typeof value === "boolean") {
      return value === ranges.green
        ? "text-white p-2 bg-green-600"
        : "p-2 bg-gray-600 text-white";
    }

    // Handle numeric ranges
    if (typeof value === "number") {
      // Check for green range
      if (value >= ranges.deepGreen.min && value <= ranges.deepGreen.max) {
        return "text-white p-2 bg-green-600";
      }

      // Check for light green range (may have alternative ranges too)
      if (
        ranges.lightGreen &&
        ((value >= ranges.lightGreen.min && value <= ranges.lightGreen.max) ||
          (ranges.lightGreen.altMin &&
            ranges.lightGreen.altMax &&
            value >= ranges.lightGreen.altMin &&
            value <= ranges.lightGreen.altMax))
      ) {
        return "text-white p-2 bg-green-300";
      }

      // Check for blue range (may have alternative ranges too)
      if (
        ranges.blue &&
        ((value >= ranges.blue.min && value <= ranges.blue.max) ||
          (ranges.blue.altMin &&
            ranges.blue.altMax &&
            value >= ranges.blue.altMin &&
            value <= ranges.blue.altMax))
      ) {
        return "text-white p-2 bg-blue-500";
      }

      // Check for blue range (may have alternative ranges too)
      if (
        ranges.yellow &&
        ((value >= ranges.yellow.min && value <= ranges.yellow.max) ||
          (ranges.yellow.altMin &&
            ranges.yellow.altMax &&
            value >= ranges.yellow.altMin &&
            value <= ranges.yellow.altMax))
      ) {
        return "text-white p-2 bg-yellow-500";
      }
      // Check for orange range (may have alternative ranges too)
      if (
        ranges.orange &&
        ((value >= ranges.orange.min && value <= ranges.orange.max) ||
          (ranges.orange.altMin &&
            ranges.orange.altMax &&
            value >= ranges.orange.altMin &&
            value <= ranges.orange.altMax))
      ) {
        return "text-white p-2 bg-orange-500";
      }

      // Check for red range (may have alternative ranges too)
      if (
        ranges.red &&
        ((value >= ranges.red.min && value <= ranges.red.max) ||
          (ranges.red.altMin &&
            ranges.red.altMax &&
            value >= ranges.red.altMin &&
            value <= ranges.red.altMax))
      ) {
        return "p-2 bg-red-600 text-white";
      }

      // Check for greyrange (may have alternative ranges too)
      if (
        ranges.grey &&
        ((value >= ranges.grey.min && value <= ranges.grey.max) ||
          (ranges.grey.altMin &&
            ranges.grey.altMax &&
            value >= ranges.grey.altMin &&
            value <= ranges.grey.altMax))
      ) {
        return "p-2 bg-gray-600 text-white";
      }
    }

    // Default fallback
    return "text-primary-blackMain";
  };

  /**
   * Gets the appropriate icon based on condition value and defined thresholds
   * @param conditionType The type of condition being evaluated (e.g., 'transformer_load_ratio')
   * @param value The actual value of the condition
   * @returns L.Icon The appropriate icon based on the condition value
   */
  const getIconForCondition = (
    conditionType: string,
    value: any
  ): L.Icon<L.IconOptions> => {
    const ranges = (THRESHOLD as any)[conditionType];

    if (!ranges) {
      return lightGreenIcon; // Default fallback
    }

    // Handle boolean type (transformer_status)
    if (typeof value === "boolean") {
      return value === ranges.green ? lightGreenIcon : greyIcon;
    }

    // Handle numeric ranges
    if (typeof value === "number") {
      if (value <= 0) {
        return greyIcon; // Default fallback for negative values
      }
      // Check for green range
      if (value >= ranges.deepGreen.min && value <= ranges.deepGreen.max) {
        return deepGreenIcon;
      }

      // Check for light green (may have alternative ranges too)
      if (
        ranges.lightGreen &&
        ((value >= ranges.lightGreen.min && value <= ranges.lightGreen.max) ||
          (ranges.lightGreen.altMin &&
            ranges.lightGreen.altMax &&
            value >= ranges.lightGreen.altMin &&
            value <= ranges.lightGreen.altMax))
      ) {
        return lightGreenIcon;
      }
      // Check for yellow range (may have alternative ranges too)
      if (
        ranges.yellow &&
        ((value >= ranges.yellow.min && value <= ranges.yellow.max) ||
          (ranges.yellow.altMin &&
            ranges.yellow.altMax &&
            value >= ranges.yellow.altMin &&
            value <= ranges.yellow.altMax))
      ) {
        return yellowIcon;
      }

      // Check for blue range (may have alternative ranges too)
      if (
        ranges.blue &&
        ((value >= ranges.blue.min && value <= ranges.blue.max) ||
          (ranges.blue.altMin &&
            ranges.blue.altMax &&
            value >= ranges.blue.altMin &&
            value <= ranges.blue.altMax))
      ) {
        return blueIcon;
      }
      // Check for orange range (may have alternative ranges too)
      if (
        ranges.orange &&
        ((value >= ranges.orange.min && value <= ranges.orange.max) ||
          (ranges.orange.altMin &&
            ranges.orange.altMax &&
            value >= ranges.orange.altMin &&
            value <= ranges.orange.altMax))
      ) {
        return orangeIcon;
      }

      // Check for red range (may have alternative ranges too)
      if (
        ranges.red &&
        ((value >= ranges.red.min && value <= ranges.red.max) ||
          (ranges.red.altMin &&
            ranges.red.altMax &&
            value >= ranges.red.altMin &&
            value <= ranges.red.altMax))
      ) {
        return redIcon;
      }
    }

    // Default fallback
    return deepGreenIcon;
  };

  // Refetch data when condition changes
  useEffect(() => {
    refetch().finally(() => {
      setisClassificationLoading(false);
    });
  }, [condition, refetch, classficationId]);

  return (
    <CardLayout
      title={t("chart.site_locations")}
      className="!min-w-[300px] lg:min-w-[350px] "
      besideTitleComponent={
        classificationLoading ? (
          // <div className="!absolute !left-[155px] !top-5">
          <Loader2 />
        ) : // </div>
        classificationError ? (
          <p className=" text-red-500">{t("error_msg.unable_to_fetch_zone")}</p>
        ) : classificationData && (classificationData as any).length > 0 ? (
          <HierarchicalSelector
            data={classificationData as any}
            selectedId={classficationId}
            disableSelect={isLoading}
            onSelect={handleClassificationChange as any}
            // className="!absolute !left-[155px] !top-5 z-10"
            // modalStyle="!mt-[-10px] !left-[150px]"
            showAll={true}
          />
        ) : null
      }
    >
      <div className="!relative h-full w-full">
        
        {isLoading ? (
          <div className="flex justify-center items-center h-full w-full">
            <Loader />
          </div>
        ) : error ? (
          (error as any).response.data.detail ? (
            <NoDeviceCardError
              message={t("feedback_msg.no_sites_found")}
              className="!max-h-[150px]"
            />
          ) : (
            <CardError
              message={t("feedback_msg.unable_to_fetch_site_map")}
              className="!h-[100px]"
            />
          )
        ) : (
          <div className="flex flex-col gap-4 w-full h-full">
            <select
              name={"conditions"}
              value={condition}
              onChange={(e) => handleConditionChange(e.target.value)}
              defaultValue={CONDITIONS[0].value}
              className="self-start cursor-pointer flex items-center px-2 py-3 justify-center rounded-full bg-gray-100 border-gray-200 border text-primary-blackMain"
            >
              {CONDITIONS.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.key}
                </option>
              ))}
            </select>

            {siteData.length > 0 && (
              <MapContainer
                center={siteData[0].position as any}
                zoom={13}
                style={{
                  height: "500px",
                  width: "100%",
                  minWidth: "300px",
                  zIndex: 1,
                }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />

                {siteData.map((site: any) => (
                  <CustomMarker
                    key={site.id}
                    site={site}
                    getIconForCondition={() =>
                      getIconForCondition(condition, site.condition)
                    }
                    getTextClassForCondition={getTextClassForCondition}
                    condition={condition}
                  />
                ))}
              </MapContainer>
            )}
            {siteData.length > 0 && (
              <MapLegend condition={condition} siteData={siteData} />
            )}
          </div>
        )}
      </div>
    </CardLayout>
  );
};

export default SiteLocationMap;
